/**
 * The words of the notice a page shows when another prest0 tab is holding up its sign-in start (2026-10-03).
 *
 * Shown only when sign-in has not answered after 10 seconds AND Firebase's own browser database could not be opened
 * in time, which happens while another tab has a delete of it waiting (an older build's sign-out did that). The broken
 * part is the other tab, so the words name the one step that clears it, and the notice goes away by itself the moment
 * sign-in answers. Registered in config/code-authored-copy.d/ (class failure).
 */

export type AuthStallLang = 'en' | 'es';

export const AUTH_STALL_NOTICE_COPY = {
  en: {
    text: 'another prest0 tab or window is holding up sign-in — close it and this tab carries on.',
    reload: 'reload',
  },
  es: {
    text: 'otra pestaña o ventana de prest0 está retrasando el inicio de sesión — ciérrala y esta pestaña continúa.',
    reload: 'recargar',
  },
} as const;

export function authStallLang(language: string | undefined | null): AuthStallLang {
  return typeof language === 'string' && language.toLowerCase().startsWith('es') ? 'es' : 'en';
}
